import { Button, Card, CardContent } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import IntegrationsAdminService from "services/admin/integrations.service";
import { toast } from "react-toastify";

export const ConnectGoogleSheets = () => {
  const { data: status } = useQuery({
    queryKey: ["integrations", "google-sheet", "status"],
    queryFn: () => IntegrationsAdminService.status("google-sheet"),
    retry: false,
  });

  const handleConnect = async () => {
    console.log("Подключение к Google Sheets");

    const { data } = await IntegrationsAdminService.connectGoogleSheets();
    console.log("data: ", data);
    if (data.url) {
      window.location.href = data.url;
    }
  };

  const handleDisconnect = async () => {
    console.log("Отсоединение от Google Sheets");
    const { data } = await IntegrationsAdminService.disconnectGoogleSheets();
    console.log("data: ", data);
    toast.success("Google Sheets отсоединен успешно!");
  };

  const buildContent = () => {
    if (!status?.data) {
      return (
        <div>
          <p className="mb-4">
            Для подключения к Google Sheets, вам нужно авторизоваться в Google и предоставить доступ
            к вашему Google Sheets. После авторизации, вы будете перенаправлены на страницу
            подключения к Google Sheets. После подключения, вы сможете использовать Google Sheets в
            вашем приложении.
          </p>
          <Button onClick={handleConnect} variant="outlined" color="primary">
            <img src="/media/images/sheet.svg" alt="Google Sheets" className="w-6 h-6 mr-2" />
            Подключить Google Sheets
          </Button>
        </div>
      );
    }

    if (status.data?.isActive) {
      return (
        <div>
          <p>Google Sheets подключен</p>
          <div>
            <Button onClick={handleDisconnect} variant="outlined" color="primary">
              Отсоединить Google Sheets
            </Button>
          </div>
        </div>
      );
    }
    return null;
  };

  return (
    <div>
      <h3 className="mb-8">Подключение к Google Sheets</h3>
      <Card>
        <CardContent>{buildContent()}</CardContent>
      </Card>
    </div>
  );
};
